import Axios, { AxiosRequestConfig } from "axios";
import { doAsync } from "./async-actions";
import AuthenticationService from "../security/AuthenticationService";
const defaultOptions = {};

export const rawApi = Axios.create(defaultOptions);

rawApi.interceptors.request.use(async (config: AxiosRequestConfig) => {
  config.baseURL = process.env.VUE_APP_API_URL;
  const token = await AuthenticationService.getToken();
  config.headers["Authorization"] = `Bearer ${token}`;

  return config;
});

// we wrap up the api
export const api = {
  getAsync(url: string, options: any = {}) {
    return AuthenticationService.getToken().then(token =>
      rawApi.get(url, {
        ...options,
        headers: {
          ...options.headers,
          Authorization: `Bearer ${token}`
        }
      })
    );
  },
  postAsync(url, data, options: any = {}) {
    return AuthenticationService.getToken().then(token =>
      rawApi.post(url, data, {
        ...options,
        headers: {
          ...options.headers,
          Authorization: `Bearer ${token}`
        }
      })
    );
  },
  get(url, asyncAction, storeCtx, options: any = {}) {
    return AuthenticationService.getToken().then(token =>
      doAsync(
        () =>
          rawApi.get(url, {
            ...options,
            headers: {
              ...options.headers,
              Authorization: `Bearer ${token}`
            }
          }),
        asyncAction,
        storeCtx
      )
    );
  },
  post(url, data, asyncAction, storeCtx, options: any = {}) {
    return AuthenticationService.getToken().then(token =>
      doAsync(
        () =>
          rawApi.post(url, data, {
            ...options,
            headers: {
              ...options.headers,
              Authorization: `Bearer ${token}`
            }
          }),
        asyncAction,
        storeCtx
      )
    );
  },
  put(url, data, asyncAction, storeCtx, options: any = {}) {
    return AuthenticationService.getToken().then(token =>
      doAsync(
        () =>
          rawApi.put(url, data, {
            ...options,
            headers: {
              ...options.headers,
              Authorization: `Bearer ${token}`
            }
          }),
        asyncAction,
        storeCtx
      )
    );
  },
  putAsync(url, data, options: any = {}) {
    return AuthenticationService.getToken().then(token =>
      rawApi.put(url, data, {
        ...options,
        headers: {
          ...options.headers,
          Authorization: `Bearer ${token}`
        }
      })
    );
  },
  deleteAsync(url, options: any = {}) {
    return AuthenticationService.getToken().then(token =>
      rawApi.delete(url, {
        ...options,
        headers: {
          ...options.headers,
          Authorization: `Bearer ${token}`
        }
      })
    );
  }
};

export default {
  api,
  rawApi
};
